import { Component, OnInit } from '@angular/core';
import { register } from 'swiper/element/bundle';

import { NotificationService } from './shared/services/notification/notification.service';

register();
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private readonly notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notificationService.initializeFCM();
  }
}